import { useRef } from 'react'
import { useNavigate } from 'react-router'

import { Images } from '@/theme/Images'
import { routes } from '@/data'
import MobileNavbar from './mobile-nav-menu'
import './navbar.css'

import ProfileDropdownMenu from './profile-dropdown-menu'

const NavBar = () => {
  const navigate = useNavigate()
  const pathname = location.pathname.split('/')[1]

  const dropDownRef = useRef(null)

  return (
    <div className="bg-brand h-[72px] w-full sticky top-0 z-10 px-[5%] md:px-[10%] flex flex-row flex-wrap justify-between items-center">
      <div className="flex flex-row justify-start items-center">
        <MobileNavbar dropDownRef={dropDownRef} />
        <img
          src={Images.fastenTextLogo}
          alt="fasten text logo"
          className="w-[187px] h-auto cursor-pointer"
          onClick={() => navigate('home/grants')}
        />
        <ul className="hidden md:flex flex-row items-center justify-start h-full px-8">
          {routes.map(item => (
            <li
              key={item?.name}
              className={`text-white text-md font-semibold px-3 py-2 ${
                pathname === item?.path ? 'bg-brand-600 rounded-md' : ''
              } cursor-pointer`}
              onClick={() => navigate(item?.path)}
            >
              {item?.name}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-row">
        <div className="bg-white h-[2.5rem] w-[2.5rem] rounded-full flex justify-center items-center ml-4 cursor-pointer">
          <ProfileDropdownMenu />
        </div>
      </div>
    </div>
  )
}

NavBar.propTypes = {}

export default NavBar
